var ProcessData = function (rawData, ledendKey, seriesKey, xAxisKey) {

  // Beacuse we don't need xAxisKey for PieGraph.js we have to set it to null
  // For all others will be the value that is passed to func
  if ( xAxisKey == void 0) {
      xAxisKey = void 0;
      // console.log('if xAxisKey:', xAxisKey);
  } else {
      // console.log('else xAxisKey:', xAxisKey);
  }

  var processedData = [];
  for (var i = 0; i < rawData.length; i++) {
      var obj = rawData[i];
      var p = {};

      for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
              if (key == ledendKey) {
                  p['legendKey'] = obj[key];
              }
              if (key == seriesKey) {
                  p['seriesKey'] = obj[key];
              }
              if (key == xAxisKey) {
                  p['xAxisKey'] = obj[key];
              }
          }
      }
      processedData.push(p);
  }
  return processedData;
}

exports.ProcessData=ProcessData;



//////////////////
// WEBPACK FOOTER
// ./src/modules/ProcessData/ProcessData.js
// module id = 9
// module chunks = 0